export const projectsData = [
  {
    id: 1,
    projectName: "Bolt Audio",
    projectDesc:
      "Bolt Audio is an e-commerce platform offering premium electronic gadgets that elevate your audio and tech experience",
    tags: ["React", "CSS", "Material Ui", "Express.JS", "Node.JS", "MongoDB"],
    code: "https://github.com/MohdTazammul/boult-audio-frontend",
    demo: "https://boult-audio.netlify.app/",
    image:
      "https://media2.giphy.com/media/Dv5KBwLFj2Uk0MMi3E/giphy.gif?cid=790b76111d15fe4274d57b59aa088fdd8c3475be705fc9fe&rid=giphy.gif&ct=g",
  },
  {
    id: 2,
    projectName: "Chat Application",
    projectDesc:
      "Real time chat-application with multiple break-out rooms, where anyone can send and receive real time messages",
    tags: ["React.JS", "Node.JS", "HarperdB", "scoket.io"],
    code: "https://github.com/alakmodak99/Chat-App",
    demo: "https://chat-application-socket.netlify.app/",
    image:
      "https://user-images.githubusercontent.com/93376849/188018093-b70af9ff-6bae-40b4-9a24-1abb35ccfaa7.PNG",
  },
  {
    id: 3,
    projectName: "PotteryBarn Website",
    projectDesc:
      "An e-commerce web application to purchase all kinds of furniture and home decoratives.",
    tags: ["HTML", "CSS", "JavaScript", "MongodB", "Node.JS", "Express.JS"],
    code: "https://github.com/alakmodak99/Pottery_Barn_Node.js",
    demo: "https://potterybarn.herokuapp.com/",
    image:
      "https://www.reviewsxp.com/blog/wp-content/uploads/2020/05/Pottery-Barn-850x491.jpg",
  },
  {
    id: 4,
    projectName: "Health Package Booking App",
    projectDesc:
      "Developed a React Native app for booking health packages across major Indian cities, serving 25K+ users with 98% session success and 40% faster load times",
    tags: ["React Native", "Node.js", "PostgreSQL", "AWS S3"],
    code: "",
    demo: "https://apps.apple.com/us/app/ampath-labs/id6473517371",
    image:
      "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 5,
    projectName: "AI Pitch Deck Generator",
    projectDesc:
      "Write presentations 10x faster and cheaper by enabling one to create slides from a seed prompt instantly using AI. Developed the complete frontend and several backend modules.",
    tags: [
      "Next.js",
      "Nest.js",
      "Socket.io",
      "PostgreSQL",
      "AWS S3",
      "GPT-3.5",
    ],
    code: "",
    demo: "https://pitchgrade.com/",
    image:
      "https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  },
];
